import "./GuestDemoNotice.css";

// Persistent, sticky disclaimer shown on every calculator/dashboard page for
// guest sessions — required to stay visible throughout the demo, not just on
// the landing screen, since that's when a visitor is looking at computed
// numbers. Rendered once in AppLayout rather than per-calculator.
export default function GuestDemoNotice() {
  return (
    <div className="guest-demo-notice" role="region" aria-label="Demo environment notice">
      <svg
        className="guest-demo-notice-icon"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="11" x2="12" y2="16" />
        <circle cx="12" cy="8" r="0.5" fill="currentColor" stroke="none" />
      </svg>
      <p className="guest-demo-notice-text">
        <strong>Demo environment</strong> — Closing costs and fees are sample
        estimates only and may not reflect actual charges in your market.
      </p>
    </div>
  );
}
